import { useEffect, useState } from "react";

export type FilterParamLogic = 'and' | 'or';
export type FilterOp = 'eq' | 'neq' | 'contains' | 'st' | 'en' | 'gt' | 'lt' | 'in';

export interface Filter {
    field: string;
    operator: FilterOp;
    value: string;
}

export interface FilterParam {
    filters: Filter[];
    logic: FilterParamLogic;
}

const filtersEqual = (left: FilterParam, right: FilterParam) => {
    if (left.logic !== right.logic) return false;
    if (left.filters.length !== right.filters.length) return false;

    for (let i = 0; i < left.filters.length; i++) {
        const leftValue = left.filters[i];
        const rightValue = right.filters[i];

        if (leftValue.field !== rightValue.field) return false;
        if (leftValue.operator !== rightValue.operator) return false;
        if (leftValue.value !== rightValue.value) return false;
    }

    return true;
};

const serializeFilters = (param?: FilterParam | null) => {
    if (param === undefined || param === null) {
        return null;
    }

    let result: string[] = [
        param.logic
    ];
    
    for (var filter of param.filters) {        
        result.push(`${filter.field}!${filter.operator}(${filter.value})`);
    }

    return result.join(';');
};

type UseFilterParamResult = [
    string | null
];

const useFilterParamString: (param?: FilterParam | null) => UseFilterParamResult = (param?: FilterParam | null) => {
    const [ result, setResult ] = useState<string | null>(null);

    useEffect(() => {
        setResult(serializeFilters(param) ?? null);
    }, [param]);

    return [
        result
    ];
};

export { filtersEqual, serializeFilters, useFilterParamString };